
function ChatbotSkeleton() {
  
  return (
    <>
      <div className="chatbot-chat-content overflow-hidden mb-4 d-flex flex-column gap-2">
        <div className="chatbot-chat-text--small chatbot-loading"></div>
      </div>
    </>
  );
  
}

export default ChatbotSkeleton;
